import React, { useEffect, useState } from "react";

const STORAGE_KEY = "rsBannerHideUntil";

export default function SmartBanner() {
  const [visible, setVisible] = useState(false);

  const IOS_URL = "https://apps.apple.com/us/app/elevate-rei/id6741596876";
  const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.jacksonrossidev.elevate&hl=en_US"; // replace with real package name
  const DEEP_LINK = "realsync://home?src=banner";

  const ua = navigator.userAgent || "";
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isIOSSafari = isIOS && isSafari;

  useEffect(() => {
    if (!isIOS && !isAndroid) return; // mobile only
    if (isIOSSafari) return; // iOS Safari shows native Apple banner

    const until = localStorage.getItem(STORAGE_KEY);
    if (until && new Date(until) > new Date()) return;

    setVisible(true);
  }, [isIOSSafari, isIOS, isAndroid]);

  const onDismiss = () => {
    const d = new Date();
    d.setDate(d.getDate() + 30);
    localStorage.setItem(STORAGE_KEY, d.toISOString());
    setVisible(false);
  };

  const onOpen = () => {
    const storeUrl = isAndroid ? ANDROID_URL : IOS_URL;
    const start = Date.now();

    const timer = setTimeout(() => {
      if (Date.now() - start < 1500) {
        window.location.href = storeUrl;
      }
    }, 800);

    try {
      window.location.href = DEEP_LINK;
    } catch {
      window.location.href = storeUrl;
    }

    setTimeout(() => clearTimeout(timer), 2500);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        background: "#0B1220",
        color: "#fff",
        padding: "10px 14px",
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <img
        src="/icons/icon-192.png"
        alt="Elevate REI"
        width={40}
        height={40}
        style={{ borderRadius: 8 }}
      />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 15 }}>Get the Elevate REI app</div>
        <div style={{ opacity: 0.85, fontSize: 13 }}>Faster, easier, built for mobile</div>
      </div>
      <button
        onClick={onOpen}
        style={{
          padding: "8px 12px",
          borderRadius: 10,
          background: "#14B869",
          color: "#0B1220",
          fontWeight: 700,
          border: "none",
          cursor: "pointer",
        }}
      >
        Open
      </button>
      <button
        onClick={onDismiss}
        style={{
          marginLeft: 8,
          background: "transparent",
          border: "none",
          color: "#fff",
          fontSize: 18,
          cursor: "pointer",
        }}
      >
        ✕
      </button>
    </div>
  );
}